import cx from '@3ui/cx';
import React from 'react';
import { Link } from 'react-router-dom';

import S from './A.module.css';

export const A = ({
  href,
  target = href.startsWith('http://') || href.startsWith('https://')
    ? '_blank'
    : undefined,
  rel = 'noreferrer noopener nofollow',
  ...props
}) =>
  href.startsWith('http://') || href.startsWith('https://') ? (
    <a
      {...props}
      className={cx(props.className, S.root)}
      href={href}
      target={target}
      rel={rel}
    />
  ) : (
    <Link {...props} to={href} className={cx(props.className, S.root)} />
  );
